import http from 'hub-http/clients/apiClient';
const API_BASE = 'users/v2/app/hub-users';
export default class HubUsersAPI {
  static getHubUsers() {
    return http.get(API_BASE);
  }
}